import Decimal from "decimal.js";

/**
 * 合計金額
 */
export default class TotalPrice {
  private price: Decimal;

  public constructor(price: Decimal.Value) {
    this.price = new Decimal(price).floor();
  }

  /**
   * 税額
   * @param taxRate 消費税率 (%)
   */
  public tax(taxRate: Decimal.Value): Decimal {
    return this.price.times(new Decimal(taxRate).div(100)).floor();
  }

  /**
   * 税込み
   * @param taxRate 消費税率 (%)
   */
  public withTax(taxRate: Decimal.Value): Decimal {
    return this.price.plus(this.tax(taxRate));
  }

  public toNumber(): number {
    return this.price.toNumber();
  }
}
